/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 资源中心，市场活动 搜索参数
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';

export default class SearchParamsController {
  /**
   * 搜索参数
   * @memberof MaterialsController
   */
  readonly SearchParams = new SearchParams({
    storageKey: 'information_search_params',
  });
  /**
   * 一级菜单烂 资源中心
   * @memberof SearchParamsController
   */
  async getMaterials_Tabs() {
    const MaterialsTabs = await AjaxBasics.requestEnum(
      lodash.merge({ body: { bu: 'SMB' } }, EnumAPI.usersvr_channel_enum),
      { labelKey: 'name', valueKey: 'code' },
    );
    this.SearchParams.merge({ MaterialsTabs });
  }
  /**
   * 二级菜单烂 资源中心
   * @memberof SearchParamsController
   */
  async getMaterials_Tabs_Two(parentCode) {
    const MaterialsTabsTwo = await AjaxBasics.requestEnum(
      lodash.merge({ body: { parentCode } }, EnumAPI.usersvr_channels),
      { labelKey: 'name', valueKey: 'code' },
    );
    this.SearchParams.merge({ MaterialsTabsTwo });
  }
  /**
   * 二级菜单烂 证书
   * @memberof SearchParamsController
   */
  async getCert_Tabs_Two() {
    const CertTabsTwo = await AjaxBasics.requestEnum(
      lodash.merge({ body: {} }, EnumAPI.cert_type),
      { labelKey: 'name', valueKey: 'code' },
    );
    this.SearchParams.merge({ CertTabsTwo });
  }
  /**
   * 证书 产品类型
   * @memberof SearchParamsController
   */
  async getCert_Product_Type() {
    const CertProductType = await AjaxBasics.requestEnum(
      lodash.merge({ body: {} }, EnumAPI.cert_product_type),
      { responseKey: 'data', labelKey: 'name', valueKey: 'code' },
    );
    this.SearchParams.merge({ CertProductType });
  }
  /**
   * 二级菜单烂 市场活动
   * @memberof SearchParamsController
   */
  async getMarket_tabs() {
    const MarketTabs = await AjaxBasics.requestEnum(
      lodash.merge({ body: { parentCode: 'A001' } }, EnumAPI.usersvr_channels),
      { labelKey: 'name', valueKey: 'code' },
    );
    // const ActiveMarketChannels = lodash.get(MarketTabs, `[0].value`)
    this.SearchParams.merge({ MarketTabs });
  }
}

class SearchParams extends BaseModel<{
  MaterialsTabs: any;
  MaterialsTabsTwo: any;
  MarketTabs: any;
  CertTabsTwo: any;
  CertProductType: any;
}> {
  /**
   * 资源中心 顶部导航
   * @readonly
   * @memberof SearchParams
   */
  @computed
  get MaterialsTabs() {
    if (lodash.size(this.value.MaterialsTabs)) {
      const result = lodash.filter(this.value.MaterialsTabs, (item: any) =>
        lodash.includes(['A003', 'A004'], item.value),
      );
      const productSource = { label: '内容中心', value: 'productSource' };
      result.push(productSource);
      return result;
    }
  }
  /**
   * 资源中心 二级菜单
   * @readonly
   * @memberof SearchParams
   */
  @computed
  get MaterialsTabsTwo() {
    if (lodash.size(this.value.MaterialsTabsTwo)) {
      return lodash.concat(
        [{ value: '', label: '全部' }],
        this.value.MaterialsTabsTwo,
      );
    }
  }
  /**
   * 证书 二级菜单
   * @readonly
   * @memberof SearchParams
   */
  @computed
  get CertTabsTwo() {
    if (lodash.size(this.value.CertTabsTwo)) {
      return lodash.concat(
        [{ value: '', label: '全部' }],
        this.value.CertTabsTwo,
      );
    }
  }
  /**
   * 证书 产品类型
   * @readonly
   * @memberof SearchParams
   */
  @computed
  get CertProductType() {
    if (lodash.size(this.value.CertProductType)) {
      return this.value.CertProductType;
    }
  }
  /**
   * 市场活动菜单
   * @readonly
   * @memberof SearchParams
   */
  @computed
  get MarketTabs() {
    return this.value?.MarketTabs || [];
  }
}
